import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import CatalogTableFilters from "components/subComponents/CatalogTableFilters";

import useCatalogList from "hooks/list/useCatalogList";

function ElencoCataloghi() {
    const catalogListHook = useCatalogList();

    const { dataTableHook, alertConfirmHook, navigateToNewCatalog } = catalogListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <CatalogTableFilters catalogListHook={catalogListHook} />

                <DataTableSimple dataTableHook={dataTableHook} />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewCatalog}>
                        Nuovo Catalogo
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoCataloghi;
